module.exports = __webpack_public_path__ + "static/media/logo.3e30b32a.png";